import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { CustomizationField, fieldOptions } from 'modules/expenses/hooks/useExpensesCustomization'

interface PaymentMethodProps {
  paymentMethod: string
  customizationFields: CustomizationField[]
}

export const PaymentMethod = ({ paymentMethod, customizationFields }: PaymentMethodProps) => {
  const paymentMethodOptions = fieldOptions('expense', 'payment_method', customizationFields)

  const getPaymentMethodLabel = (paymentMethod: string) => {
    const option = paymentMethodOptions.find((el) => el.id === paymentMethod)
    return option?.label || ''
  }
  return (
    <Box flexDirection="row" alignItems="center" gap="s6">
      <Icon.Medium icon="credit-card" />
      <Text.Normal size="200">{getPaymentMethodLabel(paymentMethod)}</Text.Normal>
    </Box>
  )
}
